import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllDepotManagementService = async (
  pageNumber,
  pageSize,
  access_token,
  searchedDepot = ""
) => {
  try {
    return axios.get(
      `${api}/Depot/GetDepotPaginationData?pageNumber=${
        searchedDepot !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${searchedDepot}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchDataforListingOptions = async (access_token) => {
  try {
    return axios.get(`${api}/Depot/AddEditOnLoadData`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const addDepotTypeManagementService = async (access_token, data) => {
  try {
    return axios.post(`${api}/Depot/AddDepot`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchDepotByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/Depot/GetById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateDepotTypeManagementService = async (
  access_token,
  data,
  id
) => {
  try {
    return axios.post(`${api}/Depot/EditDepot?Id=${id}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};
